<div>
  {{msg}}
</div>
